import { useRecordContext, useTranslate } from 'react-admin';
import { Box } from '@mui/material';
import { getOverwriteStats } from '@/helpers/parameter/parameterRecord.js';
import { ParameterChip } from '@/components/parameter/ParameterChip.jsx';

export const ParameterOverwritesField = () => {
    const record = useRecordContext();
    const translate = useTranslate();
    const stats = getOverwriteStats(record);
    const significantLabel = translate('resources.parameter.fields.isSignificant');

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
            <ParameterChip label={stats.subsetCount} tooltip={translate('resources.parameter.labels.subsetCount')} />
            <ParameterChip label={stats.nestingCount} tooltip={translate('resources.parameter.labels.nestingCount')} />
            {stats.hasLimitedScope ? <ParameterChip label={translate('resources.parameter.labels.limitedScope')} /> : null}
            {stats.hasInactiveSubset ? <ParameterChip label={translate('resources.parameter.labels.inactive')} /> : null}
            {stats.hasSignificantChangeSubset ? <ParameterChip label={significantLabel} /> : null}
        </Box>
    );
};
